import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelBrf.mjs'

export const FormItemBrfCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="brfCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemBrfTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="brfTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseBrf(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemBrfCode />
            <FormItemBrfTitle />
        </FormChooseDesign>
    )
}
